__webpack_require__.p = "https://B2BMiniBobMFE-stage.shipbob.dev/";